import { Button, Grid, useMediaQuery, useTheme, ButtonGroup } from "@material-ui/core"
import FormSection from "../../components/FormSection"
import {
  useGetOtherRequirements,
  useGetServiceDetails,
  useGetUserTips,
  useGetVehicleRequirements,
  useGetRequestAuditLog,
  useGetRideDetails
} from "../../services/queries"
import NCText from "../../shared/NCText"
import { makeStyles, Box } from "@material-ui/core"
import TopNavBar from "../../components/TopNavBar"
import NCCheckbox from "../../shared/NCCheckbox"
import { useGetClientRequestDetail } from "../../services/queries"
import { useParams } from "react-router-dom"
import {
  formatDate,
  formatAMPM,
  getAddressValue,
  loggedInUser,
  getDocNameFromPath
} from "../../libs/utils"
import NCLoader from "../../shared/NCLoader"
import NCAuditButton from "../../shared/NCAuditButton"
import NCButton from "../../shared/NCButton"
import {
  useApproveClientRequest,
  useClientRequestDecline,
  useClientRequestCancel,
  useClientRequestHold,
  useClientRequestActivate,
  useGenerateTrips
} from "../../services/mutations"
import { toast } from "react-toastify"
import { useState, Fragment } from "react"
import NCSvgIcon from "../../shared/NCSvgIcon"
import { ActionIcon, DocumentIcon } from "../../libs/icons"
import ApproveRequestModal from "../../components/request/ApproveRequestModal"
import NCModal from "../../shared/NCModal"
import NCInput from "../../shared/NCInput"
import NCDatePicker from "../../shared/NCDatePicker"
import NotificationAlert from "../../components/notification/NotificationAlert"
import { useMutation, useQueryClient } from "react-query"
import { useTranslation } from "react-i18next"
import RideDetails from "./RideDetails"
import EditRequest from "./EditRequest"
import API from "../../libs/api"
import { API_PATH } from "../../libs/config"

import NCTable from "../../shared/table/NCTable"
import { IconButton } from "@material-ui/core"

const TripList = ({ id }) => {
  const queryClient = useQueryClient()
  const { data: tripsData } = useGetRideDetails({ request_id: id })
  const trips = tripsData?.data?.data?.results || []
  const [cancelTarget, setCancelTarget] = useState(null)
  const [cancelReason, setCancelReason] = useState("")

  const cancelTrip = useMutation(
    (tripId) => API.post(`${API_PATH.TRIPS}${tripId}/admin-cancel/`, { reason: cancelReason }),
    {
      onSuccess: () => {
        toast.success("Trip cancelled")
        queryClient.invalidateQueries(["getRideDetails"])
      }
    }
  )

  const columns = [
    { Header: "Client", accessor: "client.name" },
    { Header: "Driver", accessor: "driver.name", Cell: ({ value }) => value || "—" },
    { Header: "Pickup", accessor: "pickup_address.address", Cell: ({ value }) => getAddressValue(value) || "—" },
    { Header: "Drop-off", accessor: "drop_off_address.address", Cell: ({ value }) => getAddressValue(value) || "—" },
    { Header: "Date", accessor: "pickup_time", Cell: ({ value }) => formatDate(value) || "—" },
    {
      Header: "",
      id: "action",
      disableSortBy: true,
      accessor: cell => (
        <div className="action-icons">
          <IconButton onClick={() => { setCancelReason(""); setCancelTarget(cell) }}>
            <NCText style={{ color: "#E22134", fontSize: 13, fontWeight: 600 }}>Cancel</NCText>
          </IconButton>
        </div>
      )
    }
  ]

  return (
    <>
      {trips.length > 0 ? (
        <Grid item xs={12}>
          <NCTable columns={columns} data={trips} hidePagination />
        </Grid>
      ) : (
        <NCText>No trips found</NCText>
      )}
      <NCModal
        open={!!cancelTarget}
        title="Cancel Trip"
        onClose={() => { setCancelTarget(null); setCancelReason("") }}
        submitButton={
          <NCButton
            variant="contained"
            color="secondary"
            disableElevation
            disabled={!cancelReason.trim()}
            onClick={() => {
              cancelTrip.mutate(cancelTarget.id)
              setCancelTarget(null)
              setCancelReason("")
            }}
          >
            Confirm Cancel
          </NCButton>
        }
      >
        <Box mt={1} width="100%">
          <NCText style={{ fontSize: 14, display: "block", marginBottom: 20 }}>
            You are about to cancel trip <strong>#{cancelTarget?.id}</strong>
            {cancelTarget?.pickup_time ? <> scheduled for <strong>{formatDate(cancelTarget.pickup_time)}</strong></> : ""}.
            This action cannot be undone. Are you sure you want to proceed?
          </NCText>
          <NCText style={{ fontWeight: 600, fontSize: 14, marginBottom: 8, display: "block" }}>Why cancel this trip?</NCText>
          <NCInput
            multiline
            minRows={3}
            maxRows={6}
            fullWidth
            placeholder="Enter reason for cancellation..."
            value={cancelReason}
            onChange={e => setCancelReason(e.target.value)}
          />
        </Box>
      </NCModal>
    </>
  )
}

const useStyles = makeStyles((theme) => ({
  label: { fontSize: "14px", fontWeight: "500", whiteSpace: "nowrap" },
  title: {
    fontSize: "20px"
  },
  button: {
    borderRadius: "20px",
    fontSize: "12px",
    width: "180px"
  },
  titleSection: {
    display: "flex",
    justifyContent: "space-between"
  },
  text: {
    fontSize: "14px",
    fontWeight: "400",
    display: "flex",
    alignItems: "center"
  },
  checkedItems: {
    fontSize: "14px",
    fontWeight: "400"
  },
  checklistItems: {
    fontSize: "14px",
    fontWeight: "400",  
    [theme.breakpoints.down("xs")]: {
      display: "block",
    },
  },
  subHeading: {
    fontSize: "12px",
    color: "#9CA3AF",
    fontWeight: "400"
  },
  heading: {
    fontSize: "14px",
    fontWeight: "550"
  },
  formsection: {
    marginTop: "15px"
  },
  rideContainer: {
    marginBottom: "10px"
  },
  container: {
    "& .MuiCheckbox-root": {
      paddingRight: "3px"
    }
  },
  subContainer: {
    marginBottom: "10px"
  },
  subSection: {
    paddingBottom: "10px"
  },
  approve_button: {
    backgroundColor: "#1DB954",
    color: "#FFFFFF",
    padding: "5px 20px",
    margin: "8px",
    "&:hover": {
      backgroundColor: "#64ed88"
    }
  },
  decline_button: {
    border: "1px solid #E22134",
    color: "#E22134",
    padding: "5px 20px",
    margin: "8px",
    marginRight: "1px",
    "&:hover": {
      backgroundColor: "#c2c4c0"
    }
  }
}))

const RequestDetails = () => {
  let { id } = useParams()
  const { t } = useTranslation();
  const cls = useStyles()
  const queryClient = useQueryClient()
  const [showApproveModal, setShowApproveModal] = useState(false)
  const [showDeleteModel, setShowDeleteModel] = useState(false)
  const [showCancelRecurringModal, setShowCancelRecurringModal] = useState(false)
  const [showGenerateModal, setShowGenerateModal] = useState(false)
  const [tripDate, setTripDate] = useState("")
  const generateTrips = useGenerateTrips()
  
  const [selectedTab, setSelectedTab] = useState(1)
  const { data: result, isLoading: clientRequestLoading, refetch } =
    useGetClientRequestDetail(id)
  const { data: otherRequirementsData } = useGetOtherRequirements()
  const { data: serviceDetailsData } = useGetServiceDetails()
  const { data: userTipsData } = useGetUserTips()
  const approveRequest = useApproveClientRequest("")
  const { data: vehicleRequirementsData } = useGetVehicleRequirements()
  const user = loggedInUser()
  const declineRequest = useClientRequestDecline()
  const cancelRequest = useClientRequestCancel()
  const holdRequest = useClientRequestHold()
  const activateRequest = useClientRequestActivate()
  const requestStatus = result?.data?.data?.status

  const mobileTheme = useTheme()
  const isSmallScreen = useMediaQuery(mobileTheme.breakpoints.down("sm"))

  const handleApproveClick = () => {
    setShowApproveModal(true)
  }

  const handleDeclineClick = () => {
    setShowDeleteModel(true)
  }
  const declineRequestMethod = () => {
    declineRequest.mutate(clientRequestsData.id, {
      onSuccess: () => {
        toast.success(t("requests.request_declined"))
        refetch();
        queryClient.invalidateQueries(["getClientRequestDetail"])
        queryClient.invalidateQueries(["getNotificationData"])
        queryClient.refetchQueries(["getNotificationSummary"])
      }
    })
  }

  const cancelRecurringMethod = () => {
    cancelRequest.mutate(clientRequestsData.id, {
      onSuccess: () => {
        toast.success("Recurring ride cancelled successfully")
        refetch()
        queryClient.invalidateQueries(["getClientRequestDetail"])
        queryClient.invalidateQueries(["getNotificationData"])
        queryClient.refetchQueries(["getNotificationSummary"])
        queryClient.refetchQueries(["getOverviewList"])
      }
    })
  }

  const holdRequestMethod = () => {
    holdRequest.mutate(clientRequestsData.id, {
      onSuccess: () => {
        toast.success("Request put on hold")
        refetch()
        queryClient.invalidateQueries(["getClientRequestDetail"])
        queryClient.invalidateQueries(["getNotificationData"])
        queryClient.refetchQueries(["getNotificationSummary"])
      }
    })
  }

  const activateRequestMethod = () => {
    activateRequest.mutate(clientRequestsData.id, {
      onSuccess: () => {
        toast.success("Request set active")
        refetch()
        queryClient.invalidateQueries(["getClientRequestDetail"])
        queryClient.invalidateQueries(["getNotificationData"])
        queryClient.refetchQueries(["getNotificationSummary"])
      }
    })
  }

  let clientRequestsData = result?.data?.data || null
  const { data, isLoading } = useGetRequestAuditLog(
    { request_id: id },
    { enabled: user.user_type === 1 ? true : false }
  )
  const auditData = data?.data?.data?.results || []
  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
  ]
  // const [check, setChecked] = useState(false)
  // useEffect(() => {
  //   setChecked(clientRequestsData?.is_default_driver || false)
  // }, [clientRequestsData?.is_default_driver])
  // const handleCheck = () => {
  //   setChecked(!check)
  // }
  // const approveDefaultDriver = () => {
  //   const data = {
  //     id: clientRequestsData?.id,
  //     is_default_driver: check
  //   }
  //   approveRequest.mutate(data, {
  //     onSuccess: () => {
  //       toast.success("Driver Assigned successfully!")
  //       queryClient.invalidateQueries(["getClientRequestDetail"])
  //     }
  //   })
  // }

  const approvedTitle = (
    <Grid item className={cls.titleSection}>
      {}
      {user.user_type === 4 || user.user_type === 1 || user.user_type === 2 ? <Button
        onClick={() => setShowApproveModal(true)}
        className={cls.button}
        variant="contained"
        color="primary"
      >
        {t("common.edit")}
      </Button> : null}
    </Grid>
  )
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Box mb={2} display={"flex"}>
          {/* {selectedTab === 2 ? (
            <NCText variant={"h4"} style={{ marginRight: "10px" }}>
              Ride Details
            </NCText>
          ) : ( */}
          <NCText variant={"h4"} style={{ marginRight: "10px" }}>
          {t("requests.request_details")}
          </NCText>
          {/* )} */}
        </Box>

        <Box display={"flex"}>
          {!isSmallScreen && user.user_type === 1 ? (
            <NCAuditButton data={auditData} isLoading={isLoading} />
          ) : null}
          <Box marginLeft={"5px"}>
            <NotificationAlert />
          </Box>
        </Box>
      </Grid>
      {isSmallScreen && <Grid item xs={6} sm={4}>
        <Box>
          {user.user_type === 1 ? (
            <NCAuditButton data={auditData} isLoading={isLoading} />
          ) : null}
        </Box>
      </Grid>}
      <Grid item xs={12}>
        <Box>
          <TopNavBar lastLabel={clientRequestsData?.identifier || null} />
        </Box>
      </Grid>
      {(user.user_type === 1 && requestStatus === 1) ||
        (user.user_type === 2 && requestStatus === 1) ||
        (user.user_type === 4 && requestStatus === 1) ? (
        <Grid
          item
          xs={12}
          style={{
            display: isSmallScreen ? "block" : "flex",
            justifyContent: "space-between",
            backgroundColor: "rgba(29, 185, 84, 0.1)",
            padding: "5px 10px",
            borderRadius: "8px",
            marginBottom: "15px",
            alignItems: "center"
          }}
        >
          <Box color={"green"}>
            <NCText>
              <NCSvgIcon component={ActionIcon} inheritViewBox /> {
                t("requests.approval_message")
              }
            </NCText>
          </Box>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <NCButton
              className={cls.approve_button}
              onClick={() => {
                handleApproveClick(id)
              }}
            >
              {t("common.approve")}
            </NCButton>
            <NCButton
              className={cls.decline_button}
              onClick={() => {
                handleDeclineClick(id)
              }}
            >
              {t("common.decline")}
            </NCButton>
          </Box>
        </Grid>
      ) : null}
      {(user.user_type === 1 || user.user_type === 2 || user.user_type === 4) && requestStatus === 4 ? (
        <Grid item xs={12}>
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "rgba(245, 158, 11, 0.1)",
              padding: "5px 10px",
              borderRadius: "8px",
              marginBottom: "15px"
            }}
          >
            <NCText style={{ color: "#B45309", fontWeight: 600 }}>This request is On Hold.</NCText>
            <NCButton
              variant="contained"
              color="primary"
              size="small"
              onClick={activateRequestMethod}
              style={{ width: "auto" }}
            >
              Set Active
            </NCButton>
          </Box>
        </Grid>
      ) : null}
      {(user.user_type === 1 || user.user_type === 2 || user.user_type === 4) && requestStatus === 2 ? (
        <Grid item xs={12}>
          <Grid mb={2}>
            <Box mb={2} display="flex" alignItems="center" justifyContent="space-between">
              <ButtonGroup disableElevation>
                <Button
                  style={{
                    borderStartStartRadius: "20px",
                    borderBottomLeftRadius: "20px"
                  }}
                  variant={selectedTab === 1 ? "contained" : "outlined"}
                  onClick={() => setSelectedTab(1)}
                  color={selectedTab === 1 ? "primary" : ""}
                >
                  Ride Details
                </Button>

                {result?.data?.data?.is_trip_available?<Button
                  variant={selectedTab === 2 ? "contained" : "outlined"}
                  onClick={() => setSelectedTab(2)}
                  color={selectedTab === 2 ? "primary" : ""}
                >
                  Upcoming/Current Trip
                </Button> : null}
                {/*result?.data?.data?.is_trip_available?<Button
                  style={{
                    borderStartEndRadius: "20px",
                    borderBottomRightRadius: "20px"
                  }}
                  variant={selectedTab === 3 ? "contained" : "outlined"}
                  onClick={() => setSelectedTab(3)}
                  color={selectedTab === 3 ? "primary" : ""}
                >
                  All Trips
                </Button> : null*/}
              </ButtonGroup>
              <Box display="flex" alignItems="center">
                <NCButton
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => {
                    setTripDate(new Date(Date.now() + 86400000).toISOString().split("T")[0])
                    setShowGenerateModal(true)
                  }}
                  style={{ width: "auto" }}
                >
                  Generate Trips
                </NCButton>
                <NCButton
                  variant="outlined"
                  color="secondary"
                  size="small"
                  onClick={holdRequestMethod}
                  style={{ width: "auto", marginLeft: "8px" }}
                >
                  Put On Hold
                </NCButton>
              </Box>
            </Box>
          </Grid>
        </Grid>
      ) : null} 
      {(user.user_type === 1 || user.user_type === 2 || user.user_type === 4) && requestStatus === 2 ? (
        selectedTab === 2 ? (
          <RideDetails id={id} />
        ) : selectedTab === 3 ? (
          <TripList id={id} />
        ) : (
          <EditRequest
            id={id}
            onCancel={() => setSelectedTab(1)}
            onCancelRecurring={() => setShowCancelRecurringModal(true)}
            onSaved={() => {
              setSelectedTab(1)
              refetch()
            }}
          />
        )
      ) : ( 
      <Grid item xs={12} container className={cls.container}>
        <Grid item xs={12} className={cls.rideContainer}>
          {clientRequestsData?.status === 2 ? <FormSection
            title={t("requests.approved_details")}
            subTitle={approvedTitle}
          >
            <Grid container className={cls.subContainer} spacing={2}>
              <Grid item xs={12} md={4}>
                <NCText className={cls.subHeading}>{t("requests.approve_modal.actual_start_date")}</NCText>
                <NCText className={cls.text}>
                  {formatDate(clientRequestsData?.actual_starting_date || "")}
                </NCText>
              </Grid>
              {/* {clientRequestsData?.is_a_leg_exists ? <Grid item xs={12} md={4}>
                <NCText className={cls.subHeading}>{t("requests.pickup_time")}</NCText>
                <NCText className={cls.text}>
                  {formatAMPM(clientRequestsData?.pickup_time || "")}
                </NCText>
              </Grid> : null}
              {clientRequestsData?.is_b_leg_exists ? <Grid item xs={12} md={4}>
                <NCText className={cls.subHeading}>{t("requests.bleg_eta")}</NCText>
                <NCText className={cls.text}>
                  {formatAMPM(clientRequestsData?.bleg_pickup_time || "")}
                </NCText>
              </Grid> : null} */}
            </Grid>
          </FormSection> : null}
        </Grid>
        <Grid item xs={12} className={cls.rideContainer}>
          <FormSection
            title={<span style={{ fontWeight: "500" }}>{t("requests.ride_details")}</span>}
          >
            <Grid container className={cls.subContainer} spacing={2}>
              <Grid item xs={12} md={4}>
                <NCText className={cls.subHeading}>{t("requests.starting_date")}</NCText>
                <NCText className={cls.text}>
                  {formatDate(clientRequestsData?.starting_date || "")}
                </NCText>
              </Grid>
              {clientRequestsData?.default_pickup_address?.address && (
                <Grid item xs={12} md={4}>
                  <NCText className={cls.subHeading}>Default Pickup Address</NCText>
                  <NCText className={cls.text}>
                    {clientRequestsData.default_pickup_address.address}
                  </NCText>
                </Grid>
              )}
              {clientRequestsData?.default_drop_off_address?.address && (
                <Grid item xs={12} md={4}>
                  <NCText className={cls.subHeading}>Default Drop-off Address</NCText>
                  <NCText className={cls.text}>
                    {clientRequestsData.default_drop_off_address.address}
                  </NCText>
                </Grid>
              )}
            </Grid>
          </FormSection>
        </Grid>
        {(clientRequestsData?.children || []).map((child, idx) => (
          <Grid item xs={12} className={cls.rideContainer} key={idx}>
            <FormSection
              title={<span style={{ fontWeight: "500" }}>Client {idx + 1}: {child.client_name || ""}</span>}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <NCText className={cls.subHeading}>Start Bell Time</NCText>
                  <NCText className={cls.text}>{formatAMPM(child?.start_bell_time) || "—"}</NCText>
                </Grid>
                <Grid item xs={12} md={6}>
                  <NCText className={cls.subHeading}>End Bell Time</NCText>
                  <NCText className={cls.text}>{formatAMPM(child?.end_bell_time) || "—"}</NCText>
                </Grid>
              </Grid>
              {/* {user.user_type === 4 ? (
                  <Grid item xs={12} md={6} style={{ display: "flex" }}>
                    <NCText style={{ paddingTop: "6px" }}>
                      <NCCheckbox
                        color="primary"
                        size="small"
                        checked={check}
                        onClick={() => {
                          handleCheck()
                        }}
                      />
                      Keep same driver for all rides
                    </NCText>
                    {clientRequestsData?.is_default_driver ? (
                      <Box top={8}>
                        <DriverChangeIcon
                          style={{
                            width: "30px",
                            marginLeft: "5px",
                            top: "16px",
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            approveDefaultDriver()
                          }}
                        />
                      </Box>
                    ) : (
                      <Box top={8}>
                        <DriverSaveIcon
                          style={{
                            width: "30px",
                            marginLeft: "5px",
                            top: "16px",
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            approveDefaultDriver()
                          }}
                        />
                      </Box>
                    )}
                  </Grid>
                ) : null} */}
              <FormSection
                title={<span style={{ fontSize: "14px", fontWeight: "500" }}>{t("requests.frequency")}</span>}
                customBgColor="#E5E7EB"
                subSection={true}
              >
                <Grid container spacing={5}>
                  <Grid item container xs={12} className={cls.checklistItems} style={{ gap: "20px" }}>
                    {days.map((day, i) => (
                      <NCText className={cls.checkedItems} key={i}>
                        <NCCheckbox
                          checked={child?.selected_days?.includes(day) || false}
                          color="primary"
                          size="small"
                        />
                        {day}
                      </NCText>
                    ))}
                  </Grid>
                </Grid>
              </FormSection>
              {child?.start_bell_time ? (
                <FormSection
                  title={<span style={{ fontSize: "14px", fontWeight: "500" }}>{t("requests.aleg")}</span>}
                  customBgColor="#E5E7EB"
                  subSection={true}
                >
                  <Grid container spacing={2}>
                    {(child?.pickup_addresses || []).map(address => (
                      <Fragment key={address.week_info?.name}>
                        <Grid item xs={12} sm={12} md={2}>
                          <NCText className={cls.label}>{address.week_info?.name}:</NCText>
                        </Grid>
                        <Grid item xs={6} sm={6} md={5}>
                          <NCText><span className={cls.subHeading}>{t("requests.pickup_address")}</span></NCText>
                          <NCText className={cls.text}>{getAddressValue(address?.location?.address)}</NCText>
                        </Grid>
                        <Grid item xs={6} sm={6} md={5}>
                          <NCText><span className={cls.subHeading}>{t("requests.drop_address")}</span></NCText>
                          <NCText className={cls.text}>{getAddressValue(address?.drop_location?.address)}</NCText>
                        </Grid>
                      </Fragment>
                    ))}
                  </Grid>
                </FormSection>
              ) : null}
              {child?.end_bell_time ? (
                <FormSection
                  title={<span style={{ fontSize: "14px", fontWeight: "500" }}>{t("requests.bleg")}</span>}
                  customBgColor="#E5E7EB"
                  subSection={true}
                >
                  <Grid container spacing={2}>
                    {(child?.drop_off_addresses || []).map(address => (
                      <Fragment key={address.week_info?.name}>
                        <Grid item xs={12} sm={12} md={2}>
                          <NCText className={cls.label}>{address.week_info?.name}:</NCText>
                        </Grid>
                        <Grid item xs={6} sm={6} md={5}>
                          <NCText><span className={cls.subHeading}>{t("requests.pickup_address")}</span></NCText>
                          <NCText className={cls.text}>{getAddressValue(address?.pickup_location?.address)}</NCText>
                        </Grid>
                        <Grid item xs={6} sm={6} md={5}>
                          <NCText><span className={cls.subHeading}>{t("requests.drop_address")}</span></NCText>
                          <NCText className={cls.text}>{getAddressValue(address?.location?.address)}</NCText>
                        </Grid>
                      </Fragment>
                    ))}
                  </Grid>
                </FormSection>
              ) : null}
              {/* Per-child Specific Details */}
              <FormSection
                title={<span style={{ fontSize: "14px", fontWeight: "500" }}>{t("requests.specific_details")}</span>}
                customBgColor="#FEF3C7"
                subSection={true}
              >
                {userTipsData?.data?.data?.length > 0 && (
                  <>
                    <NCText className={cls.heading}>{t("requests.pop_type")}</NCText>
                    <Grid container className={cls.subSection}>
                      {userTipsData.data.data.slice().sort((a, b) => a.id - b.id).map((item) => (
                        <Grid item xs={12} md={2} key={item.id}>
                          <NCText className={cls.checkedItems}>
                            <NCCheckbox
                              color="primary" size="small"
                              checked={(child.tips || []).includes(item.id)}
                            />
                            {item.name}
                          </NCText>
                        </Grid>
                      ))}
                    </Grid>
                  </>
                )}
                {vehicleRequirementsData?.data?.data?.length > 0 && (
                  <>
                    <NCText className={cls.heading}>{t("requests.vehicle_req")}</NCText>
                    <Grid container className={cls.subSection}>
                      {vehicleRequirementsData.data.data.map((item) => (
                        <Grid item xs={12} md={2} key={item.id}>
                          <NCText className={cls.checkedItems}>
                            <NCCheckbox
                              color="primary" size="small"
                              checked={(child.vehicle_req || []).includes(item.id)}
                            />
                            {item.name}
                          </NCText>
                        </Grid>
                      ))}
                    </Grid>
                  </>
                )}
                {serviceDetailsData?.data?.data?.length > 0 && (
                  <>
                    <NCText className={cls.heading}>{t("requests.service_details")}</NCText>
                    <Grid container className={cls.subSection}>
                      {serviceDetailsData.data.data.map((item) => (
                        <Grid item xs={12} md={2} key={item.id}>
                          <NCText className={cls.checkedItems}>
                            <NCCheckbox
                              color="primary" size="small"
                              checked={(child.service_detail || []).includes(item.id)}
                            />
                            {item.name}
                          </NCText>
                        </Grid>
                      ))}
                    </Grid>
                  </>
                )}
                {otherRequirementsData?.data?.data?.length > 0 && (
                  <>
                    <NCText className={cls.heading}>{t("requests.other")}</NCText>
                    <Grid container className={cls.subSection}>
                      {otherRequirementsData.data.data.map((item) => (
                        <Grid item xs={12} md={2} key={item.id}>
                          <NCText className={cls.checkedItems}>
                            <NCCheckbox
                              color="primary" size="small"
                              checked={(child.other || []).includes(item.id)}
                            />
                            {item.name}
                          </NCText>
                        </Grid>
                      ))}
                    </Grid>
                  </>
                )}
              </FormSection>
            </FormSection>
          </Grid>
        ))}
        <Grid item xs={12} sm={8} md={12}>
          <FormSection
            title={
              <span style={{ fontWeight: "500" }}>{t("requests.additional_comments")}</span>
            }
          >
            <Grid container>
              <Grid item xs={6}>
                <NCText>
                  <span className={cls.subHeading}>{t("requests.comment")}</span>
                </NCText>
                <NCText className={cls.text}>
                  {clientRequestsData?.additional_comment}
                </NCText>
              </Grid>
              <Grid item xs={6}>
                <NCText>
                  <span className={cls.subHeading}>{t("requests.attachment")}</span>
                </NCText>
                <NCText
                  className={`${cls.text} cursor-pointer`}
                  onClick={() => window.open(clientRequestsData?.attachment)}
                >
                  {clientRequestsData?.attachment ? <DocumentIcon /> : null}
                  {clientRequestsData?.attachment
                    ? getDocNameFromPath(clientRequestsData?.attachment)
                    : null}
                </NCText>
              </Grid>
            </Grid>
          </FormSection>
        </Grid>
      </Grid>
      )} 
      <NCLoader
        open={
          clientRequestLoading ||
          approveRequest.isLoading ||
          declineRequest.isLoading
        }
      />
      <ApproveRequestModal
        data={clientRequestsData || {}}
        modalState={showApproveModal}
        isLoading={clientRequestLoading}
        handleClose={(status) => {
          setShowApproveModal(false)
          queryClient.invalidateQueries(["getClientRequestDetail"])
          status && refetch()
        }}
      />
      <NCModal
        open={showDeleteModel}
        title={t("requests.decline_request")}
        text={t("requests.decline_request_confirmation_text")}
        onClose={() => setShowDeleteModel(false)}
        submitButton={
          <NCButton
            variant="contained"
            color="secondary"
            disableElevation
            onClick={() => {
              declineRequestMethod()
              setShowDeleteModel(false)
            }}
            style={{ width: "auto" }}
          >
            {t("common.decline")}
          </NCButton>
        }
      />
      <NCModal
        open={showCancelRecurringModal}
        title="Cancel Recurring Ride"
        text="Are you sure you want to cancel this recurring ride? All future trips for this request will be cancelled. This action cannot be undone."
        onClose={() => setShowCancelRecurringModal(false)}
        submitButton={
          <NCButton
            variant="contained"
            color="secondary"
            disableElevation
            onClick={() => {
              cancelRecurringMethod()
              setShowCancelRecurringModal(false)
            }}
            style={{ width: "auto" }}
          >
            Cancel Recurring
          </NCButton>
        }
      />
      <NCModal
        open={showGenerateModal}
        title="Generate Trips"
        text={
          <Box p={2}>
            <NCText style={{ display: "block", marginBottom: 16, fontSize: 14, color: "#D32F2F", fontWeight: 500 }}>
              ⚠ This will delete and regenerate all trips and groups for the selected date with fresh driver, aid monitor, and route assignments. This action cannot be undone.
            </NCText>
            <NCText style={{ display: "block", marginBottom: 20, fontSize: 12, color: "#757575" }}>
              System automatically generates trips daily. Only use this for corrections or recovery.
            </NCText>
            <NCDatePicker
              value={tripDate}
              onChange={(val) => setTripDate(val)}
              label="Trip Date"
              size="small"
              fullWidth
              min={new Date()}
              max={new Date(Date.now() + 7 * 86400000)}
            />
          </Box>
        }
        onClose={() => setShowGenerateModal(false)}
        submitButton={
          <NCButton
            variant="contained"
            color="primary"
            disableElevation
            onClick={() => {
              generateTrips.mutate(
                { id, trip_date: tripDate },
                {
                  onSuccess: () => {
                    toast.success("Trip generation queued!")
                    setShowGenerateModal(false)
                  },
                  onError: (err) =>
                    toast.error(err?.response?.data?.error || "Failed")
                }
              )
            }}
            disabled={generateTrips.isLoading}
            style={{ width: "auto" }}
          >
            {generateTrips.isLoading ? "Queuing..." : "Generate"}
          </NCButton>
        }
      />
    </Grid>
  )
}

export default RequestDetails
